import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { cardHover,  } from '@/animations/variants';

interface CardProps {
  title: string;
  description: string;
  icon?: string | ReactNode;
  image?: string;
  compact?: boolean;
  className?: string;
}

export default function Card({
  title,
  description,
  icon,
  image,
  compact = false,
  className = '',
}: CardProps) {
  return (
    <motion.div
      className={`
        bg-surface border border-border rounded-xl h-full flex flex-col
        ${compact ? 'p-4 sm:p-6' : 'p-6 sm:p-8'}
        hover:border-primary/50 hover:shadow-lg transition-all duration-normal
        ${className}
      `}
      variants={cardHover}
      whileHover="whileHover"
    >
      {/* Icon/Image */}
      {icon && (
        <motion.div 
          className={`${compact ? 'mb-3 sm:mb-4' : 'mb-4 sm:mb-6'} flex justify-center`}
          
        >
          {typeof icon === 'string' ? (
            <div className={`${compact ? 'text-7xl sm:text-8xl' : 'text-8xl sm:text-9xl'}`}>{icon}</div>
          ) : (
            <div className={`${compact ? 'w-24 h-24 sm:w-32 sm:h-32' : 'w-32 h-32 sm:w-36 sm:h-36'} flex items-center justify-center`}>
              {icon}
            </div>
          )}
        </motion.div>
      )}

      {image && (
        <div className={`${compact ? 'mb-3 sm:mb-4' : 'mb-4 sm:mb-6'}`}>
          <img 
            src={image} 
            alt={title}
            className="w-full h-32 sm:h-40 lg:h-48 object-cover rounded-lg"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.style.display = 'none';
            }}
          />
        </div>
      )}

      {/* Content */}
      <div className="flex-grow flex flex-col items-center text-center">
        <h3 className={`
          font-heading font-semibold text-textPrimary mb-2 sm:mb-3
          ${compact ? 'text-base sm:text-lg' : 'text-lg sm:text-xl'}
        `}>
          {title}
        </h3>
        <p className={`
          text-textSecondary leading-relaxed flex-grow
          ${compact ? 'text-xs sm:text-sm' : 'text-sm sm:text-base'}
        `}>
          {description}
        </p>
      </div>
    </motion.div>
  );
}